/* Lift Easy Townlec — global.js
   Vanilla JS, progressive enhancement. No external dependencies. */
(function () {
  'use strict';

  /* ---------- Mobile drawer ---------- */
  var drawer = document.querySelector('[data-drawer]');
  var overlay = document.querySelector('[data-drawer-overlay]');
  var openBtn = document.querySelector('[data-drawer-open]');
  var closeEls = document.querySelectorAll('[data-drawer-close]');
  var lastFocused = null;

  function openDrawer() {
    if (!drawer) return;
    lastFocused = document.activeElement;
    drawer.setAttribute('aria-hidden', 'false');
    if (overlay) overlay.setAttribute('aria-hidden', 'false');
    if (openBtn) openBtn.setAttribute('aria-expanded', 'true');
    document.body.style.overflow = 'hidden';
    var firstLink = drawer.querySelector('a, button');
    if (firstLink) firstLink.focus();
  }
  function closeDrawer() {
    if (!drawer) return;
    drawer.setAttribute('aria-hidden', 'true');
    if (overlay) overlay.setAttribute('aria-hidden', 'true');
    if (openBtn) openBtn.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = '';
    if (lastFocused) lastFocused.focus();
  }
  if (openBtn) openBtn.addEventListener('click', openDrawer);
  closeEls.forEach(function (el) { el.addEventListener('click', closeDrawer); });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      if (drawer && drawer.getAttribute('aria-hidden') === 'false') closeDrawer();
    }
  });

  /* ---------- Drawer accordion sub-menus ---------- */
  document.querySelectorAll('[data-submenu-toggle]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var expanded = btn.getAttribute('aria-expanded') === 'true';
      btn.setAttribute('aria-expanded', String(!expanded));
      var panel = btn.nextElementSibling;
      if (panel) panel.setAttribute('data-open', String(!expanded));
    });
  });

  /* ---------- Desktop mega-menu: keyboard + click accessibility ---------- */
  document.querySelectorAll('[data-mega-trigger]').forEach(function (trigger) {
    var item = trigger.closest('.nav__item');
    if (!item) return;
    trigger.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        item.classList.toggle('nav__item--open');
        trigger.setAttribute('aria-expanded', item.classList.contains('nav__item--open'));
      }
    });
    item.addEventListener('mouseleave', function () {
      item.classList.remove('nav__item--open');
      trigger.setAttribute('aria-expanded', 'false');
    });
  });

  /* ---------- Quantity steppers ---------- */
  document.querySelectorAll('[data-qty]').forEach(function (wrap) {
    var input = wrap.querySelector('input');
    wrap.querySelectorAll('[data-qty-btn]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var step = btn.getAttribute('data-qty-btn') === 'plus' ? 1 : -1;
        var val = parseInt(input.value, 10) || 1;
        var next = Math.max(parseInt(input.min, 10) || 1, val + step);
        input.value = next;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
  });

  /* ---------- Product gallery thumbnails ----------
     NOTE: the main image is rendered by image_tag with a srcset + sizes.
     A srcset ALWAYS beats src, so swapping .src alone does nothing —
     the srcset/sizes must be rewritten at the same time. */
  var galleryMain = document.querySelector('[data-gallery-main] img');
  var galleryThumbs = document.querySelectorAll('[data-gallery-thumb]');

  function widthUrl(url, w) {
    if (!url) return url;
    return /[?&]width=\d+/.test(url)
      ? url.replace(/([?&]width=)\d+/, '$1' + w)
      : url + (url.indexOf('?') === -1 ? '?' : '&') + 'width=' + w;
  }

  function showGalleryImage(thumb) {
    if (!galleryMain) return;
    var full = thumb.getAttribute('data-full');
    if (full) {
      var srcset = [400, 600, 800, 1000].map(function (w) {
        return widthUrl(full, w) + ' ' + w + 'w';
      }).join(', ');
      galleryMain.setAttribute('srcset', srcset);
      galleryMain.setAttribute('sizes', '(min-width:768px) 48vw, 100vw');
      galleryMain.setAttribute('src', full);
      galleryMain.removeAttribute('width');
      galleryMain.removeAttribute('height');
      galleryMain.removeAttribute('loading');
      var timg = thumb.querySelector('img');
      if (timg && timg.alt) galleryMain.alt = timg.alt;
    }
    galleryThumbs.forEach(function (t) { t.setAttribute('aria-current', 'false'); });
    thumb.setAttribute('aria-current', 'true');
  }

  galleryThumbs.forEach(function (thumb) {
    thumb.addEventListener('click', function () { showGalleryImage(thumb); });
  });

  /* ---------- Variant select: update price + SKU ---------- */
  var variantSelect = document.getElementById('variant-select');
  if (variantSelect) {
    variantSelect.addEventListener('change', function () {
      var opt = variantSelect.options[variantSelect.selectedIndex];
      var priceEl = document.querySelector('.product__price .price');
      var skuEl = document.querySelector('.product__sku');
      if (priceEl && opt.getAttribute('data-price')) priceEl.firstChild && (priceEl.childNodes[0].nodeValue = opt.getAttribute('data-price') + ' ');
      if (skuEl && opt.getAttribute('data-sku')) skuEl.textContent = skuEl.textContent.split(':')[0] + ': ' + opt.getAttribute('data-sku');
    });
  }

  /* ---------- AJAX add-to-cart (progressive enhancement) ---------- */
  document.querySelectorAll('form[action$="/cart/add"]').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      if (!window.fetch) return; // fallback to normal POST
      e.preventDefault();
      var btn = form.querySelector('[type="submit"]');
      var original = btn ? btn.textContent : '';
      if (btn) { btn.disabled = true; btn.textContent = '…'; }
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Accept': 'application/json' },
        body: new FormData(form)
      })
        .then(function (r) { return r.json(); })
        .then(function () { return fetch('/cart.js', { headers: { 'Accept': 'application/json' } }); })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          document.querySelectorAll('[data-cart-count]').forEach(function (el) {
            el.textContent = cart.item_count;
            el.hidden = false;
          });
          if (btn) { btn.textContent = 'Added ✓'; }
          setTimeout(function () { if (btn) { btn.disabled = false; btn.textContent = original; } }, 1400);
        })
        .catch(function () {
          if (btn) { btn.disabled = false; btn.textContent = original; }
          form.submit();
        });
    });
  });
})();
